import { IdNameObjectItem } from './id-name-item'

export type Gender = IdNameObjectItem<string>

export const genders: Gender[] = [
  { id: 'male', name: $localize`Male` },
  { id: 'female', name: $localize`Female` },
]
